var parent = require('../../../es/array/virtual/keys');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/array/virtual/keys.js
// module id = 4082
// module chunks = 25